import { SEARCH_INPUT_MAX_LENGTH } from "./constants";

export function trimSearchQuery(input: string) {
  return input.trim().slice(0, SEARCH_INPUT_MAX_LENGTH);
}
